import React, {useState, useEffect} from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import { ChainSorter } from "chainsorter";

import Box from '../components/ui/Box.js';
import PayrollView from '../components/attendance/payrollview2.js';
import PayrollAddForm from '../components/attendance/payrolladdform.js';
import Loadable from '../components/ui/loading/Loadable.js';
import Filterable from '../components/ui/filter/Filterable.js';
import api from '../api/index.js';

import './Payroll.scss';

const PayrollPage = (props) => {
	
	const [date, setDate] = useState(new Date());
	const [periodType, setPeriodType] = useState(false);
	const [startDate, setStartDate] = useState(false);
	const [endDate, setEndDate] = useState(false);
	const [children, setChildren] = useState(false);
	//const [rates, setRates] = useState(false);
	//const [overtime, setOvertime] = useState(false);
	//const [ratetypes, setRatetypes] = useState(false);

	const onAddSubmit = (d) => {
		refresh(date);
		return true;
	}

	const filter = (data, filterstring) => {
		let filtered = [];
		const f = filterstring.toLowerCase();
		for(let i in data) {
			const d = data[i];
			const name = (d.Employee.FirstName + ' ' + d.Employee.LastName).toLowerCase();
			if (name.includes(f)) {
				filtered.push(d);
			}
		}
		return filtered;
	}

	const onDateChange = (d) => { 
		setDate(d);
		if (d > moment(endDate) || d < moment(startDate)) {
			refresh(d, true);
		}
	}

	const offsetDate = (i) => {
		let m = moment(i == 1 ? endDate : startDate);
		m = m.add(i, 'day');
		onDateChange(m.toDate());
	}

	const refresh = async (date, datechanged = false) => {
		if (datechanged) {
			setChildren(false);
			//setRates(false);
		}

		try {
			let d = (await api.getsoft('attendance/payperiod/' + date.api()));
			setPeriodType(d['type']);
			setStartDate(d['range'][0]);
			setEndDate(d['range'][1]);

			//let rt = await api.getsoft('attendance/ratetypes');
			//setRatetypes(rt);

			//let c = (await api.get('attendance/chunk/?from=' + d['range'][0] + '&until=' + d['range'][1]));
			let c = (await api.get('attendance/payroll/?from=' + d['range'][0] + '&until=' + d['range'][1]));
			//console.log(c);

			c = ChainSorter(c).custom((a,b) => {
				if (a.Employee.FirstName > b.Employee.FirstName)
					return 1;
				if (a.Employee.FirstName < b.Employee.FirstName)
					return -1;
				if (a.Employee.LastName > b.Employee.LastName)
					return 1;
				if (a.Employee.LastName < b.Employee.LastName)
					return -1;
				return 0;
			}).sort()
/*
			let employeeIds = c.map(x => x['Employee']['EmployeeID']).join(",");
			if (employeeIds.length > 0) {
				let r = (await api.get('employees/rates/?from=' + d['range'][0] + '&until=' + d['range'][1] + '&employees=' + employeeIds));
				setRates(r);
				let o = (await api.getsoft('attendance/overtime/?from=' + d['range'][0] + '&until=' + d['range'][1]));
				setOvertime(o);
			} else {
				setRates([]);
			}*/
			setChildren(c);
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	useEffect(() => {
		if (periodType === false) {
			refresh(date);
		}
	});


	const onUpdated = (d) => {
		refresh(date);
	}

	// passProps={{'startDate': startDate, 'endDate': endDate, 'onUpdated': onUpdated, 'overtime': overtime, 'rates': rates, 'ratetypes': ratetypes}}
	// The date stuff should be at the top like the year select
	return <><Loadable ready={periodType !== false}>
		<h2>Payroll: {periodType}</h2>
		<p className="range-selector">
		<button className="block ish previous" onClick={offsetDate.bind(this, -1)}>&laquo; Previous</button><span>
			&nbsp;<strong>{startDate}</strong> to <strong>{endDate}</strong>&nbsp;
	
		</span><button className="block ish next" onClick={offsetDate.bind(this, +1)}>Next &raquo;</button>
		</p>
	</Loadable>
	<Loadable ready={children !== false}>
		<Filterable 
			summaryComponent={PayrollView}
			addForm={PayrollAddForm}
			onAddSubmit={onAddSubmit}
			filter={filter}
			children={children}
			type="payroll"
			passProps={{'onUpdated': onUpdated}}
		/>
	</Loadable></>;
}
export default PayrollPage;